import React, { useState } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStop, faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useFinalizarInventario } from '../../../../hooks/useSngpc';

interface BotaoFinalizarInventarioProps {
    disabled?: boolean;
}

const BotaoFinalizarInventario: React.FC<BotaoFinalizarInventarioProps> = ({ disabled }) => {
    const [showModal, setShowModal] = useState(false);
    const finalizarInventarioMutation = useFinalizarInventario();

    const handleConfirmar = async () => {
        try {
            await finalizarInventarioMutation.mutateAsync();
            setShowModal(false);
        } catch (error) {
            console.error('Erro ao finalizar inventário:', error);
        }
    };

    return (
        <>
            <Button
                variant="danger"
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                <FontAwesomeIcon icon={faStop} className="me-2" />
                Finalizar
            </Button>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon icon={faStop} className="me-2 text-danger-emphasis" />
                        Finalizar Inventário
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center py-3">
                        <FontAwesomeIcon icon={faStop} size="3x" className="text-danger-emphasis mb-3" />
                        <h5 className="mb-3">Finalizar Inventário</h5>
                        <p className="text-body-tertiary mb-4">
                            Tem certeza de que deseja finalizar o inventário?
                        </p>
                        <Alert variant="warning" className="border border-warning border-opacity-25 bg-warning-subtle text-start">
                            <div className="text-warning-emphasis">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                <strong>Ação irreversível:</strong>
                                <ul className="mb-0 mt-2">
                                    <li>O inventário será fechado definitivamente</li>
                                    <li>Não será mais possível fazer alterações</li>
                                    <li>Os dados serão consolidados no sistema</li>
                                </ul>
                            </div>
                        </Alert>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleConfirmar}
                        disabled={finalizarInventarioMutation.isPending}
                    >
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {finalizarInventarioMutation.isPending ? 'Finalizando...' : 'Confirmar Finalização'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BotaoFinalizarInventario; 